<div class="automatic-audience-members-list w-100-p">
    <mat-toolbar-row class="automatic-audience-members-toolbar" fxLayout="row" fxLayoutAlign="space-between center">
        <app-search-outline [searchInput]="searchInput"></app-search-outline>

        <div fxLayout="row" fxLayoutAlign="end center" *ngIf="actionPermissions?.canShowActionsMenu">
            <button
                mat-raised-button
                color="accent"
                class="mat-elevation-z0"
                fxLayout="row"
                [matMenuTriggerFor]="membersActionsMenu"
                [disabled]="hasNoUsers"
                aria-label="More"
            >
                <span>
                    {{ actionsUserCount || 0 }}
                    {{ 'GENERAL.LABEL.USER' | translate: { total: actionsUserCount } }}
                </span>
                <mat-icon>keyboard_arrow_down</mat-icon>
            </button>

            <mat-menu #membersActionsMenu="matMenu" xPosition="before" class="users-actions-menu-panel">
                <button mat-menu-item (click)="downloadUsers()" [disabled]="hasNoUsers" *ngIf="actionPermissions.canDownload">
                    <mat-icon class="mr-8">cloud_download</mat-icon>
                    <span>{{ 'GENERAL.BUTTON.DOWNLOAD_XLSX' | translate }}</span>
                </button>

                <button
                    mat-menu-item
                    (click)="openPasswordlessAccessDialog()"
                    [disabled]="hasNoUsers"
                    *ngIf="actionPermissions.canCreatePasswordless && actionPermissions.isPasswordlessLoginFeatureEnabled"
                >
                    <mat-icon svgIcon="qr_code" class="mr-8"></mat-icon>
                    <span>{{ 'USER.BUTTON.CREATE_PASSWORDLESS_ACCESS' | translate }}</span>
                </button>

                <button mat-menu-item (click)="openAssignUserToTeamDialog()" [disabled]="hasNoUsers" *ngIf="actionPermissions.canAssignTeam">
                    <mat-icon svgIcon="team" class="mr-8"></mat-icon>
                    <span>{{ 'USER.BUTTON.ASSIGN_TO_TEAM' | translate }}</span>
                </button>

                <button mat-menu-item (click)="assignUsersToExperience()" [disabled]="hasNoUsers" *ngIf="actionPermissions.canAssignExperience">
                    <mat-icon svgIcon="assign_user_to_experience" class="mr-8"></mat-icon>
                    <span>{{ 'GENERAL.BUTTON.ASSIGN_TO_EXPERIENCE' | translate }}</span>
                </button>

                <button mat-menu-item (click)="assignUsersToAudience()" [disabled]="hasNoUsers" *ngIf="actionPermissions.canAssignAudience">
                    <mat-icon svgIcon="assign_user_to_audience" class="mr-8"></mat-icon>
                    <span>{{ 'GENERAL.BUTTON.ASSIGN_TO_AUDIENCE' | translate }}</span>
                </button>

                <button mat-menu-item (click)="assignUsersToCourse()" [disabled]="hasNoUsers" *ngIf="actionPermissions.canAssignCourse">
                    <mat-icon class="mr-8">school</mat-icon>
                    <span>{{ 'GENERAL.BUTTON.TAKE_OVER' | translate }}</span>
                </button>

                <button
                    mat-menu-item
                    (click)="resetPasswords()"
                    [disabled]="hasNoUsers"
                    *ngIf="actionPermissions.canResetPassword && !actionPermissions.isSSOFeatureEnabled"
                >
                    <mat-icon svgIcon="lock_reset" class="mr-8"></mat-icon>
                    <span>{{ 'USER.BUTTON.RESET_PASSWORDS' | translate: { total: actionsUserCount } }}</span>
                </button>

                <button mat-menu-item (click)="removeUsers()" [disabled]="hasNoUsers" *ngIf="actionPermissions.canRemove">
                    <mat-icon class="mr-8">delete</mat-icon>
                    <span>{{ 'GENERAL.BUTTON.REMOVE' | translate }}</span>
                </button>
            </mat-menu>
        </div>
    </mat-toolbar-row>

    <div class="content white">
        <mat-table
            #table
            [dataSource]="users"
            matSort
            matSortActive="{{ sortBy }}"
            matSortDirection="{{ sortOrder }}"
            class="mat-elevation-z0"
            [class.hidden]="isLoading || showNoSearchResults"
        >
            <ng-container matColumnDef="checkbox">
                <mat-header-cell *matHeaderCellDef>
                    <mat-checkbox
                        (click)="$event.stopPropagation()"
                        (change)="masterToggle()"
                        [checked]="selectedUserIds.length && isAllSelected"
                        [indeterminate]="isIndeterminateSelection"
                        [disabled]="!users.length"
                    >
                    </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let user">
                    <mat-checkbox
                        [(ngModel)]="checkboxes[user.id]"
                        (ngModelChange)="toggleUserSelection(user)"
                        (click)="$event.stopPropagation()"
                    >
                    </mat-checkbox>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="avatar">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell class="user-details-card-container" *matCellDef="let user">
                    <div class="relative" #avatarCell>
                        <img class="avatar pointer" *ngIf="user?.avatar?.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                        <ng-template #initials>
                            <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                        </ng-template>
                        <ng-template [onlineStateIndicator]="user.isOnline"></ng-template>
                    </div>
                    <app-user-details-card
                        [class.hidden]="isUserDetailsCardHidden"
                        [user]="user"
                        [target]="avatarCell"
                        openedFrom="contact_card_allusers"
                        (goToAction)="goToUserProfile(user.id)"
                    ></app-user-details-card>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="firstName">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="active-user-list-mat-header">{{
                    'GENERAL.PROPERTY.FIRST_NAME' | translate
                }}</mat-header-cell>
                <mat-cell *matCellDef="let user">
                    <div
                        #firstNameRow
                        class="text-truncate font-medium pointer"
                        [matTooltip]="user.firstName"
                        [matTooltipDisabled]="firstNameRow.scrollWidth <= firstNameRow.clientWidth"
                        [matTooltipShowDelay]="500"
                    >
                        {{ user.firstName }}
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="lastName">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="active-user-list-mat-header">{{
                    'GENERAL.PROPERTY.LAST_NAME' | translate
                }}</mat-header-cell>
                <mat-cell *matCellDef="let user">
                    <div
                        #lastNameRow
                        class="text-truncate font-medium pointer"
                        [matTooltip]="user.lastName"
                        [matTooltipDisabled]="lastNameRow.scrollWidth <= lastNameRow.clientWidth"
                        [matTooltipShowDelay]="500"
                    >
                        {{ user.lastName }}
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm class="active-user-list-mat-header">{{
                    'GENERAL.PROPERTY.EMAIL' | translate
                }}</mat-header-cell>
                <mat-cell *matCellDef="let user" fxHide fxShow.gt-sm>
                    <div
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        class="bg-gray-100 hover:bg-gray-200 py-8 pr-16 pl-8 rounded-full text-truncate"
                        (click)="$event.stopPropagation()"
                    >
                        <mat-icon svgIcon="send_message" class="mr-8 icon-18"></mat-icon>
                        <a
                            #emailEl
                            class="text-truncate"
                            [href]="'mailto:' + user.email"
                            target="_top"
                            (click)="$event.stopPropagation()"
                            [matTooltip]="user.email"
                            [matTooltipDisabled]="emailEl.scrollWidth <= emailEl.clientWidth"
                            [matTooltipShowDelay]="500"
                            >{{ user.email }}</a
                        >
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="buttons">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let user">
                    <div fxLayout="row" fxLayoutAlign="end center" *ngIf="actionPermissions?.canShowActionsMenu">
                        <button mat-icon-button [matMenuTriggerFor]="rowActionsMenu" aria-label="More" (click)="$event.stopPropagation()">
                            <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                        </button>

                        <mat-menu #rowActionsMenu="matMenu" xPosition="before">
                            <button
                                mat-menu-item
                                (click)="openPasswordlessAccessDialog([user.id])"
                                [disabled]="user.status !== 'active'"
                                *ngIf="actionPermissions.canCreatePasswordless && actionPermissions.isPasswordlessLoginFeatureEnabled"
                            >
                                <mat-icon svgIcon="qr_code" class="mr-8"></mat-icon>
                                <span>{{ 'USER.BUTTON.CREATE_PASSWORDLESS_ACCESS' | translate }}</span>
                            </button>

                            <button mat-menu-item (click)="openAssignUserToTeamDialog([user.id])" *ngIf="actionPermissions.canAssignTeam">
                                <mat-icon svgIcon="team" class="mr-8"></mat-icon>
                                <span>{{ 'USER.BUTTON.ASSIGN_TO_TEAM' | translate }}</span>
                            </button>

                            <button mat-menu-item (click)="assignUsersToExperience([user.id])" *ngIf="actionPermissions.canAssignExperience">
                                <mat-icon svgIcon="assign_user_to_experience" class="mr-8"></mat-icon>
                                <span>{{ 'GENERAL.BUTTON.ASSIGN_TO_EXPERIENCE' | translate }}</span>
                            </button>

                            <button mat-menu-item (click)="assignUsersToAudience([user.id])" *ngIf="actionPermissions.canAssignAudience">
                                <mat-icon svgIcon="assign_user_to_audience" class="mr-8"></mat-icon>
                                <span>{{ 'GENERAL.BUTTON.ASSIGN_TO_AUDIENCE' | translate }}</span>
                            </button>

                            <button mat-menu-item (click)="assignUsersToCourse([user.id])" *ngIf="actionPermissions.canAssignCourse">
                                <mat-icon class="mr-8">school</mat-icon>
                                <span>{{ 'GENERAL.BUTTON.TAKE_OVER' | translate }}</span>
                            </button>

                            <button
                                mat-menu-item
                                (click)="resetPasswords([user.id])"
                                *ngIf="actionPermissions.canResetPassword && !actionPermissions.isSSOFeatureEnabled"
                            >
                                <mat-icon svgIcon="lock_reset" class="mr-8"></mat-icon>
                                <span>{{ 'USER.BUTTON.RESET_PASSWORDS' | translate: { total: 1 } }}</span>
                            </button>

                            <button mat-menu-item (click)="removeUsers([user.id])" *ngIf="actionPermissions.canRemove">
                                <mat-icon class="mr-8">delete</mat-icon>
                                <span>{{ 'GENERAL.BUTTON.REMOVE' | translate }}</span>
                            </button>
                        </mat-menu>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row
                *matRowDef="let user; columns: displayedColumns"
                class="relative group pointer hover:bg-gray-50"
                (click)="goToUserProfile(user.id)"
            ></mat-row>
        </mat-table>

        <div class="white" fxLayout="column" fxLayoutAlign="center center" *ngIf="isLoading">
            <div class="shimmer-container min-w-full p-0">
                <div class="shimmer p-12">
                    <div class="shimmer-card !max-w-full table h-480 animate"></div>
                </div>
            </div>
        </div>

        <div
            *ngIf="showNoSearchResults"
            class="automatic-audience-members-no-results empty-state-container-modern my-0 mx-auto"
            fxLayout="column"
            fxLayoutAlign="center center"
        >
            <mat-icon class="participant-view-illustration" svgIcon="search_no_results_modern"></mat-icon>
            <h3>{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h3>
            <p>{{ 'GENERAL.MESSAGE.SEARCH_NO_RESULTS' | translate }}</p>
        </div>

        <mat-paginator persistPageSize="grow.automatic-audience-members-list"
            [class.hidden]="isLoading || showNoSearchResults || !users.length"
            [length]="totalCount"
            [pageSize]="10"
            [pageSizeOptions]="[10, 25, 50]"
        ></mat-paginator>
    </div>
</div>
